import { IStepInformation } from './Tutorial';


export const Mp3DownloadTutorialSteps = [
    {
        headerText: 'In order to submit for credit, you’ll need your authorization code',
        bodyText: 'During the program, an authorization code will be announced. When you finish the segment, open the player and click on the “Credit” panel where you will be prompted to enter this code.',
    },
] as Array<IStepInformation>;
